// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"c6c2f6c9","787":"9d2df192","874":"78f69564"}[chunkId] + ".chunk.js";
};